/**
 * @voltxampere/engine — UUID helper for the worker client (Sprint 9)
 *
 * Browser `crypto.randomUUID()` is native; Node < 19 needs the
 * `node:crypto` module. Rather than shipping a polyfill, we
 * detect at runtime and throw a clear error in unsupported
 * environments. Sprint 9 targets modern browsers + Node ≥ 18.17
 * (where `crypto.randomUUID` is exposed in `globalThis`), so the
 * fallback branch is vanishingly rare.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export function randomUUID() {
    const g = globalThis;
    if (g.crypto && typeof g.crypto.randomUUID === "function") {
        return g.crypto.randomUUID();
    }
    throw new Error("VoltXAmpere worker client requires crypto.randomUUID support (Node ≥ 18.17 or modern browser)");
}
//# sourceMappingURL=uuid.js.map